import { render, staticRenderFns } from "./updatestore.vue?vue&type=template&id=66eb8fe7&scoped=true"
import script from "./updatestore.vue?vue&type=script&lang=js"
export * from "./updatestore.vue?vue&type=script&lang=js"
import style0 from "./updatestore.vue?vue&type=style&index=0&id=66eb8fe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb8fe7",
  null
  
)

export default component.exports